import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, isRequestSuccessed } = useRequest({
    name: 'GET_PREVIEWS',
    url: `/api/worklines/group/preview`,
  });

  return [data || [], isRequestSuccessed];
});
